export const DESIGN_REGISTRY_GET_BOT_REPORT = 'DESIGN_REGISTRY_GET_BOT_REPORT';
export const DESIGN_REGISTRY_GET_BOT_REPORT_SUCCESS = 'DESIGN_REGISTRY_GET_BOT_REPORT_SUCCESS';
export const DESIGN_REGISTRY_GET_BOT_REPORT_FAIL = 'DESIGN_REGISTRY_GET_BOT_REPORT_FAIL';

export const DESIGN_REGISTRY_GET_BOT_REPORT_CLEAR = 'DESIGN_REGISTRY_GET_BOT_REPORT_CLEAR';
